import {useState} from "react";
import {useNotificationStore} from "@/Stores/NotificationStore";
import {useBasketStore} from "@/Stores/Site/Basket";
import {getProductByArticle} from "@/entities/product/api/productApi";
import {addOrUpdateBasket} from "@/entities/basket/api/basketApi";
import {trackAddToBasket} from "@/features/basket-actions/analytics/trackAddToBasket";
import {getInitialProductData} from "@/features/quickView";
import {basketEvents} from "@/shared/lib/events";
import {useAddProductInBasketStore} from "@/widgets/add-product-in-basket-modal";

export function useAddToBasket() {
    const [loading, setLoading] = useState(false);

    const setBasketProducts = useBasketStore(state => state.setBasketProducts);
    const openModal = useAddProductInBasketStore(state => state.actions.openModal);
    const setProduct = useAddProductInBasketStore(state => state.actions.setProduct);
    const setProductDataCurrent = useAddProductInBasketStore(state => state.actions.setProductDataCurrent);
    const show = useNotificationStore(state => state.show);

    const addToBasket = async ({productId, productDataId, article, price}) => {
        try {
            if (loading) return;

            setLoading(true);

            if (productDataId) {
                await handleAdd(productId, productDataId, price);
                return;
            }

            const response = await getProductByArticle({
                article,
                type: 'addBasket',
            });
            const {success = {}} = response.data;
            const {status = false, data = []} = success;

            if (!status) throw new Error('Не удалось получить данные');

            const {product = {}} = data;
            const {product_data = []} = product;
            if (product.product_data.length === 1 && product_data[0].razmer === '') {
                await handleAdd(product.id, product_data[0].id, price);
                return;
            }

            const {productDataCurrent} = getInitialProductData(product);
            setProduct(product);
            setProductDataCurrent(productDataCurrent);
            openModal();
        } catch (e) {
            handleError();
        } finally {
            setLoading(false);
        }
    };

    const handleAdd = async (productId, productDataId, price) => {
        try {
            const response = await addOrUpdateBasket({
                productId,
                productDataId,
                count: 1,
                returnProduct: true,
                operationType: 'create',
            });

            const {success} = response.data;
            const {status = false, data = [], errors = []} = success;

            if (!status) throw new Error('Произошла ошибка при добавлении товара!');

            setBasketProducts(data.basketProducts);

            // Временно скрываю
            // show({
            //     text: 'Товар добавлен!',
            //     basket: true,
            // });

            trackAddToBasket({data, price, count: 1, productId});

            // Событие (данные в корзине изменены)
            basketEvents.added.emit();
        } catch (e) {
            handleError();
        }
    }

    const handleError = (message = 'Произошла ошибка при добавлении товара!') => {
        show({
            text: message,
            severity: 'error',
        });
    };

    return {addToBasket, loading};
}
